import { ActionList, ActionTypes } from '../../actions/invoices/actions-segments-options';
import { Options } from '../../models/invoices/segments.options.model';

export interface State {
  apply: boolean;
  data: Options;
}

export const initialState = {
  apply: true,
  data: {
    dateFrom: '',
    dateTo: '',
    offices: []
  }
};

/* eslint-disable */
export function reducer(state = initialState, action: ActionList) {
  switch (action.type) {
    case ActionTypes.Change:
      return { data: action.payload.options, apply: action.payload.apply };
    case ActionTypes.Reset:
      const resetOptions = (action.payload && action.payload.options) || initialState.data;
      return { data: resetOptions, apply: true };
    case ActionTypes.Apply:
      return { ...state, apply: true };
    default:
      return state;
  }
}
